import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { LoginContext } from '../context/LoginContext'


export default function Header() {
    const { logoutUser } = useContext(LoginContext)
    return (
        <>
            <nav className="navbar navbar-light navbar-glass fs--1 font-weight-semi-bold row navbar-top sticky-kit navbar-expand">
                {/* content top nav bar */}
                <style
                    dangerouslySetInnerHTML={{
                        __html:
                            "\n   #notificationsImprovments .notification{flex-wrap:wrap;}\n   .loading-preview{    flex: 0 0 100%;display: block;text-align: center; padding:20px 0}\n   .loading-preview .page-loader{display:inline-block}\n   #notificationsImprovments .list-group-item .notification-flush{padding:.5rem 1rem}\n   #notificationsImprovments .dropdown-menu {\n      overflow-y: auto;\n   }   \n   #rpc .notification{\n      align-items: center;\n      justify-content: space-between;      \n   }\n   .prc-loader > div{display:inline-block;}\n   .rpc-stats, .rpc-no-stats{display:none}\n   #navbarDropdownRevenue:hover .revenue-icon-bottom{fill:#000;}\n   #rpc.show svg{fill:#5292e8 !important;}\n",
                    }}
                />
                <button
                    className="navbar-toggler collapsed"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarVerticalCollapse"
                    aria-controls="navbarVerticalCollapse"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon" />
                </button>
                <div className="collapse navbar-collapse" id="navbarNavDropdown1">
                    <ul className="navbar-nav align-items-center ml-auto">
                        <li>
                            <Link
                                className="btn btn-sm btn-falcon-primary btn-info"
                                to="/dashboard/contact-us"
                            >
                                Need Integration Help? Run troubleshooter
                                <span className="fas fa-angle-right ml-1" />
                            </Link>
                        </li>
                        <li className="nav-item dropdown">
                            <a
                                className="nav-link pr-0"
                                id="navbarDropdownUser"
                                href="/"
                                role="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <div
                                    className="avatar avatar-xl"
                                    style={{ fontSize: "34px", marginTop: "-12px" }}
                                >
                                    <i className="fas fa-user-circle" />
                                </div>
                            </a>
                            <div
                                className="dropdown-menu dropdown-menu-right py-0 nav-user-dropdown"
                                aria-labelledby="navbarDropdownUser"
                            >
                                <div className="bg-white rounded-soft py-2">
                                    <Link
                                        className="dropdown-item"
                                        to="/account/profile"
                                    >
                                        Profile &amp; account
                                    </Link>
                                    <Link
                                        className="dropdown-item"
                                        to="/account/team-members"
                                    >
                                        Team Members
                                    </Link>
                                    <div className="dropdown-divider" />
                                    {/* <Link
                                        className="dropdown-item"
                                        to="/account/invoice"
                                    >
                                        Billing History
                                    </Link> */}
                                    <Link className="dropdown-item" to="/account/wallet">Billing History</Link>
                                    <Link
                                        className="dropdown-item"
                                        to="/account/plans"
                                    >
                                        Plans
                                    </Link>
                                    <div className="dropdown-divider" />
                                    <div onClick={logoutUser} className="dropdown-item cursor-pointer">Logout</div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
        </>
    )
}
